import { chakra, useStyles } from '@chakra-ui/system';
import React from 'react';
import { usePaginationContext } from '../pagination';
import { PageSelect } from './page-select';
export var PageSizing = _ref => {
  var {
    label
  } = _ref;
  var pageCxt = usePaginationContext();
  var styles = useStyles();

  if (!pageCxt.onSizeChange) {
    throw new Error('Need to provide props: onSizeChange + pageSize');
  }

  return /*#__PURE__*/React.createElement(chakra.div, {
    __css: styles.sizing
  }, /*#__PURE__*/React.createElement(chakra.p, {
    fontWeight: "normal"
  }, label), /*#__PURE__*/React.createElement(PageSelect, {
    options: (pageCxt.selectableSizes || [25]).map(SIZE => ({
      label: SIZE,
      value: SIZE
    })),
    selectProps: {
      value: pageCxt.pageSize,
      onChange: _ref2 => {
        var {
          target
        } = _ref2;
        pageCxt.onSizeChange == null ? void 0 : pageCxt.onSizeChange(Number(target.value));
      }
    }
  }));
};
//# sourceMappingURL=page-sizing.js.map